export const setStylesInfoPannel = (theme) => {
  return {
    ctn: {
      display: 'flex',
      flexDirection: 'column',
      gap: '32px',
    },
    needHelp: {
      fontWeight: '600',
      fontSize: '1.375rem',
      lineHeight: '1.75rem',
      color: '#202336',
    },
    faq: {
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '24px',
      color: '#282B3E',
      letterSpacing: 0,

      '& span': {
        fontWeight: 600,
        lineHeight: '28px',
        borderBottom: '1px solid #0000C1',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
      },
    },
    hr: {
      width: '100%',
      background: '#8E90A2',
    },
    note: {
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '28px',
      color: '#202336',

      '& span': {
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '28px',
      },
    },
  };
};
